import axios, { AxiosResponse } from 'axios';

// API服务类，封装所有API调用
export class ApiService {
  // 历史记录相关API
  static async getHistorySplit(userId: string): Promise<AxiosResponse> {
    return axios.get('/db/getHistorySplit', {
      params: { userId }
    });
  }

  static async deleteHistory(userId: string, id: string): Promise<AxiosResponse> {
    return axios.postForm('/db/delHistory', {
      userId,
      id
    });
  }

  // VIP相关API
  static async getVipExpire(userId: string): Promise<AxiosResponse> {
    return axios.postForm('/api/pay/getVipExpire', {
      userId
    });
  }

  // 音频处理API
  static async processAudio(filePath: string): Promise<AxiosResponse> {
    return axios.get('/a2t/process', {
      params: { filePath }
    });
  }

  // PV上报API
  static async reportPV(data: {
    userId: string | undefined;
    guestId: string | null;
    isGuest: boolean;
  }): Promise<AxiosResponse> {
    return axios.postForm('/db/pvReport', data);
  }

  // 权限检查API
  static async checkSuperAdmin(email: string): Promise<AxiosResponse> {
    return axios.post('/auth/checkSuperAdmin', {
      email
    });
  }

  // 支付相关API
  static async createPayment(data: {
    amount: number;
    currency: string;
    description: string;
    metadata: any;
  }): Promise<AxiosResponse> {
    return axios.post('/api/payment/create', data);
  }

  static async addOrderTest(data: any): Promise<AxiosResponse> {
    return axios.postForm('/api/pay/addOrderLogTest', data);
  }

  // 文件上传API
  static async uploadFile(data: FormData): Promise<AxiosResponse> {
    return axios.post('/api/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  // 转录API
  static async transcribe(data: any): Promise<AxiosResponse> {
    return axios.post('/api/transcribe', data);
  }

  // 添加历史记录API
  static async addHistory(data: {
    userId: string;
    email?: string;
    createTime: number;
    result: string;
    input: string;
  }): Promise<AxiosResponse> {
    return axios.postForm('/db/addHistory', data);
  }

  // 提交评测
  static async addEvaluation(data: {
    result: string;
    Content: string;
    Industry: string;
    Output_type: string;
    historyId: string;
  }): Promise<AxiosResponse> {
    return axios.postForm('/db/addEvaluation', data);
  }

  // 添加历史记录API
  static async getEvaluation(data: {
    historyId: string;
  }): Promise<AxiosResponse> {
    return axios.postForm('/db/getEvaluation', data);
  }

  // 获取历史记录列表（支持分页和时间筛选）
  static async getHistoryList(params: {
    userId: string;
    startTime?: number;
    endTime?: number;
    pageSize?: number;
    current?: number;
  }): Promise<AxiosResponse> {
    return axios.get('/db/getHistoryList', {
      params
    });
  }

  // 获取带有评测状态的历史记录列表
  static async getHistoryListWithEvaluation(params: {
    // userId: string;
    id?: string;
    startTime?: number;
    endTime?: number;
    pageSize?: number;
    current?: number;
  }): Promise<AxiosResponse> {
    return axios.get('/db/getHistoryListWithEvaluation', {
      params
    });
  }



  // 重新评测
  static async reEvaluate(historyId: string): Promise<AxiosResponse> {
    return axios.post('/db/reEvaluate', null, {
      params: {
        historyId
      }
    });
  }

  // 生成标题
  static async generateTitle(historyId: string): Promise<AxiosResponse> {
    return axios.post('/db/generateTitle', null, {
      params: {
        historyId
      }
    });
  }

  // 更新历史记录标题
  static async updateHistoryTitle(id: string, title: string): Promise<AxiosResponse> {
    return axios.post('/db/updateHistoryTitle', null, {
      params: {
        id,
        title
      }
    });
  }

  // 自定义模板相关API
  
  // 添加自定义模板
  static async addCustomTemplate(data: API.CustomTemplateAddRequest): Promise<AxiosResponse<API.CustomTemplateAddResponse>> {
    return axios.get('/api/template/add', {
      params: data
    });
  }

  // 搜索用户自定义模板
  static async searchCustomTemplates(data: API.CustomTemplateSearchRequest): Promise<AxiosResponse<API.CustomTemplateListResponse>> {
    return axios.get('/api/template/search', {
      params: data
    });
  }

  // 删除自定义模板
  static async deleteCustomTemplate(data: API.CustomTemplateDeleteRequest): Promise<AxiosResponse<API.CustomTemplateDeleteResponse>> {
    return axios.get('/api/template/delete', {
      params: data
    });
  }

  // 聊天调试API
  static async chatDebug(data: API.ChatDebugRequest): Promise<AxiosResponse<API.ChatDebugResponse>> {
    return axios.post('/api/chat/debug', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}

export const {
  getHistorySplit,
  deleteHistory,
  getVipExpire,
  processAudio,
  reportPV,
  createPayment,
  addOrderTest,
  uploadFile,
  transcribe,
  addHistory,
  generateTitle,
  updateHistoryTitle,
  addCustomTemplate,
  searchCustomTemplates,
  deleteCustomTemplate,
  chatDebug
} = ApiService;